import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for loading card customisation
 * Returns styling for loading state
 */
export const useLoadingCardCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT_TRANSACTIONS,
    sectionKey: PUI.CHATBOT_TRANSACTIONS_SECTION_KEYS.LOADING_CARD,
    blockKey: PUI.CHATBOT_TRANSACTIONS_BLOCK_KEYS.TRANSACTIONS,
  });

  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const borderColor = getField(PUI.COMMON_FIELD_KEYS.BORDER_COLOR);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);

  return {
    isVisible,
    backgroundColor,
    borderColor,
    textColor,
  };
};

/**
 * Composable for error card customisation
 * Returns styling for error state
 */
export const useErrorCardCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT_TRANSACTIONS,
    sectionKey: PUI.CHATBOT_TRANSACTIONS_SECTION_KEYS.ERROR_CARD,
    blockKey: PUI.CHATBOT_TRANSACTIONS_BLOCK_KEYS.TRANSACTIONS,
  });

  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const borderColor = getField(PUI.COMMON_FIELD_KEYS.BORDER_COLOR);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const subTextColor = getField(PUI.COMMON_FIELD_KEYS.SUB_TEXT_COLOR);

  return {
    isVisible,
    backgroundColor,
    borderColor,
    textColor,
    subTextColor,
  };
};

/**
 * Composable for empty list customisation
 * Returns text content and styling for empty state
 */
export const useEmptyListCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT_TRANSACTIONS,
    sectionKey: PUI.CHATBOT_TRANSACTIONS_SECTION_KEYS.EMPTY_LIST,
    blockKey: PUI.CHATBOT_TRANSACTIONS_BLOCK_KEYS.TRANSACTIONS,
  });

  const textContent = getField(PUI.COMMON_FIELD_KEYS.TEXT_CONTENT);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const borderColor = getField(PUI.COMMON_FIELD_KEYS.BORDER_COLOR);

  return {
    isVisible,
    textContent,
    textColor,
    backgroundColor,
    borderColor,
  };
};

/**
 * Composable for select button customisation
 * Returns text and styling for select button
 */
export const useSelectButtonCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT_TRANSACTIONS,
    sectionKey: PUI.CHATBOT_TRANSACTIONS_SECTION_KEYS.SELECT_BUTTON,
    blockKey: PUI.CHATBOT_TRANSACTIONS_BLOCK_KEYS.ACTIONS,
  });

  const buttonText = getField(PUI.COMMON_FIELD_KEYS.BUTTON_TEXT);
  const buttonTextColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_TEXT_COLOR);
  const buttonBorderColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_BORDER_COLOR);
  const buttonBackgroundColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_BACKGROUND_COLOR);
  const disabledButtonTextColor = getField(PUI.COMMON_FIELD_KEYS.DISABLED_BUTTON_TEXT_COLOR);
  const disabledButtonBorderColor = getField(PUI.COMMON_FIELD_KEYS.DISABLED_BUTTON_BORDER_COLOR);
  const disabledButtonBackgroundColor = getField(PUI.COMMON_FIELD_KEYS.DISABLED_BUTTON_BACKGROUND_COLOR);

  return {
    isVisible,
    buttonText,
    buttonTextColor,
    buttonBorderColor,
    buttonBackgroundColor,
    disabledButtonTextColor,
    disabledButtonBorderColor,
    disabledButtonBackgroundColor,
  };
};

/**
 * Composable for load more button customisation
 * Returns text and styling for load more button
 */
export const useLoadMoreButtonCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT_TRANSACTIONS,
    sectionKey: PUI.CHATBOT_TRANSACTIONS_SECTION_KEYS.LOAD_MORE_BUTTON,
    blockKey: PUI.CHATBOT_TRANSACTIONS_BLOCK_KEYS.ACTIONS,
  });

  const buttonText = getField(PUI.COMMON_FIELD_KEYS.BUTTON_TEXT);
  const buttonTextColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_TEXT_COLOR);
  const buttonBorderColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_BORDER_COLOR);
  const buttonBackgroundColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_BACKGROUND_COLOR);

  return {
    isVisible,
    buttonText,
    buttonTextColor,
    buttonBorderColor,
    buttonBackgroundColor,
  };
};

/**
 * Composable for cancel button customisation
 * Returns text and styling for cancel button
 */
export const useCancelButtonCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT_TRANSACTIONS,
    sectionKey: PUI.CHATBOT_TRANSACTIONS_SECTION_KEYS.CANCEL_BUTTON,
    blockKey: PUI.CHATBOT_TRANSACTIONS_BLOCK_KEYS.ACTIONS,
  });

  const buttonText = getField(PUI.COMMON_FIELD_KEYS.BUTTON_TEXT);
  const buttonTextColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_TEXT_COLOR);
  const buttonBorderColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_BORDER_COLOR);
  const buttonBackgroundColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_BACKGROUND_COLOR);

  return {
    isVisible,
    buttonText,
    buttonTextColor,
    buttonBorderColor,
    buttonBackgroundColor,
  };
};
